import * as React from "react";
import {Text, TouchableWithoutFeedback, View} from "react-native";
import moment from "moment-timezone";
import {Spinner} from "@ui-kitten/components";
import {MaterialCommunityIcons} from "@expo/vector-icons";

export const PickupRequestItem = ({
                                      type,
                                      date,
                                      scheduled_at,
                                      onCancel
                                  }) => {
    const [cancelLoader, setCancelLoader] = React.useState(false)

    return (
        <View style={{marginBottom: 15, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
            <View>
                <Text style={{color: 'white', fontWeight: 'bold'}}>{date}</Text>
                {type == 'unscheduled' && <Text style={{color: 'white', fontSize: 13}}>scheduling in progress</Text>}
                {type == 'scheduled' && <Text style={{color: 'white'}}>pick up scheduled
                    around {moment(scheduled_at).format('YYYY-MM-DD HH:mm')}</Text>}
                {type == 'collected' && <Text style={{color: 'white'}}>collected</Text>}
            </View>

            {type == 'unscheduled' && (cancelLoader ? <Spinner status="basic"/> :
                <TouchableWithoutFeedback onPress={async id => {
                    setCancelLoader(true)
                    await onCancel(id)
                    setCancelLoader(false)
                }}>
                    <MaterialCommunityIcons name="delete-forever" size={24} color="white"/>
                </TouchableWithoutFeedback>)}
        </View>
    )
}